import React from "react";
import "../styles.css"
import { CardIcon } from "./icons/icons";

export const MODAL_CONFIGS = {
    SUCCESS: ({ navigate, summary }) => ({
        iconType: "check",
        title: "¡Todo listo!",
        description: (
            <>
                <p className="m-0">Hemos actualizado tu suscripción exitosamente.</p>
                <p className="m-0">Tu gimnasio ahora tiene la capacidad que necesitas.</p>

                <div className="modal-config-summary-box mt-3">
                    <div className="d-flex flex-row align-items-center justify-content-between w-100">
                        <span className="modal-config-summary-box-title">Plan</span>
                        <strong>{summary.planName}</strong>
                    </div>
                    <div className="d-flex flex-row align-items-center justify-content-between w-100">
                        <span className="modal-config-summary-box-title">Transacción ID</span>
                        <strong className="modal-config-summary-box-value">{summary.transactionId}</strong>
                    </div>
                    <div className="d-flex flex-row align-items-center justify-content-between w-100">
                        <span className="modal-config-summary-box-title">Total Pagado</span>
                        <strong className="modal-config-summary-box-value success">{summary.totalPaid}</strong>
                    </div>
                </div>
            </>
        ),
        primaryAction: {
            label: "Volver al Dashboard",
            onClick: () => navigate("/admin/")
        },
        width: "327px"
    }),

    CONFIRM_PAYMENT: ({ handleSkipTrial, openCancelModal, summary, navigate }) => ({
        iconType: "clock",
        title: "¿Listo para oficializar tu plan?",
        description: (
            <div className="d-flex flex-column gap-2">
                <div className="inline-modal-description ">
                    Para personalizar o cambiar tu plan actual, debemos dar inicio a tu membresía completa.
                </div>
                <div className="inline-modal-description">
                    Esto finalizará tu prueba gratuita automáticamente y activará tu ciclo de facturación a partir de hoy.
                </div>
                <div className="inline-modal-description">
                    ¡Comencemos a elevar tu gestión!
                </div>

                <div className="amount-box mt-1">
                    <div className="d-flex flex-column gap-2 align-items-start ">
                        <span>MONTO A PAGAR</span>
                        <strong>{summary?.amountToPay}</strong>
                    </div>
                    <CardIcon />
                </div>

                <div className="modal-config-actions d-flex flex-column gap-3 justify-content-center align-items-center px-3 mt-1">
                    <button className="btn btn-primary" onClick={handleSkipTrial}>Pagar y Continuar</button>
                    <button className="btn btn-secondary" onClick={() => navigate("/admin/")}>Volver</button>
                    <span className="">¿Prefieres detener tu progreso?</span>
                    <a className="btn btn-link danger" onClick={openCancelModal}>Cancelar mi suscripción y prueba gratuita</a>
                </div>
            </div>
        ),
        width: "327px"
    }),

    CANCEL_WARNING: ({ navigate, closeModal, cancelSubscription }) => ({
        iconType: "infoError",
        title: "¿Seguro que quieres perder el control de tu negocio?",
        description: (
            <>
                <div className="d-flex flex-column gap-3">
                    <span className="inline-modal-description">
                        Si cancelas ahora, se desactivará tu acceso inmediato al panel de administración.
                    </span>

                    <span className="inline-modal-description">
                        Ten en cuenta que perderás la gestión de:
                    </span>

                    <div className="d-flex flex-column">
                        <span className="inline-modal-description">📅 Módulo de Reservas y Asistencia</span>
                        <span className="inline-modal-description">📊 Gráficas de Salud del Negocio</span>
                        <span className="inline-modal-description">👥 Accesos para tus Administrativos y Staff</span>
                        <span className="inline-modal-description">💪 Creación de Planes de Entrenamiento y Membresías</span>
                    </div>

                    <span className="inline-modal-description">
                        Tu cuenta pasará a estado inactivo y la operación de tu centro podría detenerse.
                    </span>
                </div>
            </>
        ),
        primaryAction: {
            label: "¡No! Quiero mantener el control",
            onClick: () => navigate("/admin/")
        },
        secondaryAction: {
            label: "Sí, cancelar",
            onClick: cancelSubscription
        },
        width: "338px"
    }),

    TRIAL_EXPIRING_WARNING: ({ handleSkipTrial, navigate, summary, remindTomorrow }) => ({
        iconType: "clock",
        title: `Tu prueba gratuita termina en ${summary?.daysLeft} días`,
        description: (
            <div className="d-flex flex-column gap-3">
                <span className="inline-modal-description">
                    Para seguir gestionando tu gimnasio sin interrupciones,
                    es necesario activar tu membresía antes de que finalice la prueba.
                </span>

                <span className="inline-modal-description">
                    Si no realizas la activación, se suspenderá el acceso a las métricas
                    y reportes de rendimiento de tus atletas.
                </span>

                <div className="amount-box mt-1">
                    <div className="d-flex flex-column gap-2 align-items-start">
                        <span>MONTO A PAGAR</span>
                        <strong>{summary?.totalWithDiscount}</strong>
                    </div>
                    <CardIcon />
                </div>

                <div className="modal-config-actions d-flex flex-column gap-2 justify-content-center align-items-center px-3 mt-1">
                    <button
                        className="btn btn-primary"
                        onClick={handleSkipTrial}
                    >
                        Activar membresía ahora
                    </button>

                    <button
                        className="btn btn-link"
                        onClick={remindTomorrow}
                    >
                        Recordármelo mañana
                    </button>
                </div>
            </div>
        ),
        width: "327px"
    }),

    TRIAL_ENDED_CONFIRM_PAYMENT: ({ summary, handlePayment, handleOpenAddPaymentMethodModal }) => ({
        iconType: "clock",
        title: "Tu prueba gratuita ha finalizado",
        description: (
            <div className="d-flex flex-column gap-2">
                <div className="d-flex flex-column">
                    <div className="inline-modal-description">
                        Tu periodo de prueba terminó hoy.
                    </div>
                    <div className="inline-modal-description">
                        Intentamos procesar el pago a tu tarjeta guardada Visa •• 4242 pero requerimos tu confirmación.
                    </div>
                </div>
                <div className="amount-box mt-1">
                    <div className="d-flex flex-column gap-2 align-items-start ">
                        <span>MONTO A PAGAR</span>
                        <strong>{summary?.amountToPay}</strong>
                    </div>
                    <CardIcon />
                </div>
                <div className="modal-config-actions d-flex flex-column gap-3 justify-content-center align-items-center px-3 mt-1">
                    <button className="btn btn-primary" onClick={handlePayment}>Pagar y Continuar</button>
                    <button className="btn btn-link" onClick={handleOpenAddPaymentMethodModal}>Actualizar método de pago</button>
                </div>
            </div>
        ),
        width: "327px"
    }),

    PAYMENT_REJECTED: ({ closeModal, handlePayment, handleOpenAddPaymentMethodModal }) => ({
        iconType: "infoError",
        title: "Pago Rechazado",
        description: (
            <div className="d-flex flex-column gap-3">
                <span className="inline-modal-description">
                    La transacción ha sido rechazada. Por favor verifica que los datos ingresados sean correctos (número de tarjeta, fecha de vencimiento, CVC) e inténtalo nuevamente.
                </span>

                <div className="modal-config-actions d-flex flex-column gap-2 justify-content-center align-items-center px-3 mt-1">
                    <button className="btn btn-danger" onClick={handleOpenAddPaymentMethodModal}>Actualizar método de pago</button>
                    <button className="btn btn-link" onClick={handlePayment}>Intentar nuevamente</button>
                    <button className="btn btn-link" onClick={closeModal}>Cerrar</button>
                </div>
            </div>
        ),
        width: "337px"
    }),

    PAYMENT_REJECTED_UPDATE: ({ handleOpenAddPaymentMethodModal, closeModal }) => ({
        iconType: "infoError",
        title: "No fue posible completar la actualización",
        description: (
            <div className="d-flex flex-column gap-3">
                <span className="inline-modal-description">
                    Ocurrió un problema al procesar el pago durante la actualización de tu plan.
                    Por favor revisa o actualiza tu método de pago e inténtalo nuevamente.
                </span>

                <div className="modal-config-actions d-flex flex-column gap-2 justify-content-center align-items-center px-3 mt-1">
                    <button
                        className="btn btn-danger"
                        onClick={handleOpenAddPaymentMethodModal}
                    >
                        Actualizar método de pago
                    </button>
                    <button
                        className="btn btn-link"
                        onClick={closeModal}
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        ),
        width: "337px"
    }),

    SUBSCRIPTION_SUSPENDED: ({ summary, handlePlanReactivation, handleOpenAddPaymentMethodModal }) => ({
        iconType: "lock",
        title: "Suscripción Detenida",
        description: (
            <div className="d-flex flex-column gap-3">
                <span className="inline-modal-description">
                    Tu plan <strong>{summary?.planName}</strong> se detuvo.
                    El acceso a tu panel ha sido pausado temporalmente.
                </span>

                <div className="modal-config-summary-box align-items-start gap-1">
                    <span className="inline-modal-description">👥 Gestión de atletas</span>
                    <span className="inline-modal-description">📊 Base de datos y reportes</span>
                    <span className="inline-modal-description">📅 Reservas automáticas</span>
                </div>

                <span className="text-center px-2 inline-modal-description">
                    Al reactivar, se realizará automáticamente el cobro de <strong>{summary?.totalWithDiscount || "la tarifa de tu plan"}</strong> a tu método de pago registrado.
                </span>

                <div className="modal-config-actions d-flex flex-column gap-2 justify-content-center align-items-center px-3 mt-1">
                    <button className="btn btn-danger" onClick={handlePlanReactivation}>Reactivar suscripción</button>
                    <button className="btn btn-link" onClick={handleOpenAddPaymentMethodModal}>Cambiar método de pago</button>
                </div>
            </div>
        ),
        width: "327px"
    }),

    USER_LIMIT_REACHED: ({ navigate, closeModal }) => ({
        iconType: "info",
        title: "Límite de usuarios alcanzado",
        description: (
            <div className="d-flex flex-column gap-2">
                <span className="inline-modal-description">
                    Has llegado al número máximo de usuarios incluidos en tu plan.
                </span>
                <span className="inline-modal-description">
                    Para continuar agregando más atletas, adquiere un nuevo paquete.
                </span>
            </div>
        ),
        primaryAction: {
            label: "Adicionar más usuarios",
            onClick: () => navigate("/admin/edit-member")
        },
        secondaryAction: {
            label: "Cerrar",
            onClick: () => closeModal()
        },
        width: "327px"
    }),

    UPDATE_ALERT: ({ navigate, closeModal, handleOpenAddPaymentMethodModal, canClose }) => ({
        iconType: "info",
        title: "Actualización Requerida",
        description: (
            <div className="d-flex flex-column gap-3">
                <span className="inline-modal-description">
                    ¡Hola! Para tu comodidad y buscando la facilidad de tus clientes, Elevva a partir de la próxima fecha de vencimiento de tu plan te invita a que elijas un nuevo plan de cobertura y anexes la tarjeta.
                </span>

                <div className="modal-config-actions d-flex flex-column gap-2 justify-content-center align-items-center px-3 mt-1">
                    <button className="inline-modal-button-primary w-100" onClick={handleOpenAddPaymentMethodModal}>
                        Registrar Tarjeta de Crédito
                    </button>
                    {canClose && (
                        <button className="btn btn-secondary w-100" onClick={closeModal}>
                            Cerrar
                        </button>
                    )}
                    <span className="">
                        <svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                            <path d="M0.666748 7.33464C0.666748 6.07756 0.666748 5.44902 1.05727 5.05849C1.4478 4.66797 2.07634 4.66797 3.33342 4.66797H8.66675C9.92383 4.66797 10.5524 4.66797 10.9429 5.05849C11.3334 5.44902 11.3334 6.07756 11.3334 7.33464V8.66797C11.3334 10.5536 11.3334 11.4964 10.7476 12.0822C10.1618 12.668 9.21903 12.668 7.33341 12.668H4.66675C2.78113 12.668 1.83832 12.668 1.25253 12.0822C0.666748 11.4964 0.666748 10.5536 0.666748 8.66797V7.33464Z" stroke="#9DACBD" stroke-width="1.33333" />
                            <path d="M8.66683 4.0013V3.33463C8.66683 1.86188 7.47292 0.667969 6.00016 0.667969C4.5274 0.667969 3.3335 1.86188 3.3335 3.33463V4.0013" stroke="#9DACBD" stroke-width="1.33333" stroke-linecap="round" />
                        </svg>
                        Tus datos están protegidos y encriptados.
                    </span>

                </div>

            </div>
        ),
        width: "338px"
    }),

};
